<template>
    <div id="wrapper" class="outer">
        <router-view></router-view>
        <footer>©2020</footer>
    </div>
</template>

<script>
export default {
  name: 'outerPage',
  components: {
  },
  data: () => ({
  }),
  created(){

  }
};
</script>
<style lang="scss">
    .outer{
        background: #F0F0F8;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        footer{
            width: 100%;
            padding: 20px;
            text-align: center;
            font-size: 12px;
            color: #AEAED5;
        }
    }
</style>